import { Modal, Form, Button, App, Select, InputNumber, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
import { DeleteOutlined, OrderedListOutlined } from '@ant-design/icons';
var ClassItem = models.classes.ClassItem;
var TeamSource = models.teams.TeamSource;
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
export const AssignStartNumbers = (props) => {
    const { competition_id, classItem, disabled } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const openModal = () => {
        setVisible(true);
    };
    const handleCancel = () => {
        form.resetFields();
        setVisible(false);
    };
    useEffect(() => {
        if (visible) {
            form.resetFields();
        }
    }, [visible, form]);
    const getDefaultValue = () => ({
        first_number: 10,
        reuse_numbers: 1,
        randomize_order: 1
    });
    const handleReset = async (done) => {
        await Api.call(TeamSource(competition_id).url, "reset-start-numbers", {
            class_id: classItem === null || classItem === void 0 ? void 0 : classItem.class_id
        })
            .catch(err => {
            notification.error({
                message: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        });
        done();
        handleCancel();
    };
    const onFinish = async (fieldsValues) => {
        setIsLoading(true);
        await Api.call(TeamSource(competition_id).url, "assign-start-numbers", {
            ...fieldsValues,
            class_id: classItem === null || classItem === void 0 ? void 0 : classItem.class_id
        })
            .catch(err => {
            notification.error({
                message: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        });
        setIsLoading(false);
        handleCancel();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { disabled: disabled, icon: React.createElement(OrderedListOutlined, null), onClick: openModal }, _T('team.assign.label')),
        React.createElement(Modal, { title: React.createElement(Space, null,
                _T('team.assign.label'),
                classItem && ClassItem.getClassLabel(classItem)), open: visible, width: 700, onCancel: handleCancel, footer: [
                React.createElement(ButtonConfirm, { key: "reset", title: _T('common.delete.title'), description: _T('common.delete.content', { name: _T('team.details.team_start_number.label').toLowerCase() }), onConfirm: handleReset, buttonProps: {
                        danger: true,
                        icon: React.createElement(DeleteOutlined, null)
                    } }),
                React.createElement(Button, { key: "cancel", onClick: handleCancel, disabled: isLoading }, _T('common.cancel.title')),
                React.createElement(Button, { key: "submit", type: "primary", onClick: () => form.submit(), disabled: isLoading, loading: isLoading }, _T('common.apply.title'))
            ] },
            React.createElement(Form, { form: form, labelCol: { span: 8 }, wrapperCol: { span: 16 }, disabled: isLoading, onFinish: onFinish, initialValues: getDefaultValue() },
                React.createElement(Form.Item, { name: "first_number", label: _T('team.assign.first_number'), rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(InputNumber, { min: 10, style: { width: '100%' } })),
                React.createElement(Form.Item, { name: "reuse_numbers", label: _T('team.assign.reuse_numbers'), extra: _T('team.assign.reuse_numbers_hint'), rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: 0, key: 0 }, _T('common.disabled')),
                        React.createElement(Select.Option, { value: 1, key: 1 }, _T('common.enable')))),
                React.createElement(Form.Item, { name: "randomize_order", label: _T('team.assign.randomize_order'), rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: 0, key: 0 }, _T('common.disabled')),
                        React.createElement(Select.Option, { value: 1, key: 1 }, _T('common.enable'))))))));
};
